import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Tabs, Tab } from "react-bootstrap";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import SequenceTab from "./Tabs/sequence";
import DepartJobTab from "./Tabs/depart";
import handleChangeWebsiteTab from "../../../../commons/ChangeWebsiteTab";

export default function WorkOrderStatusInformation() {
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();

  const handleChangeTab = (key) => {
    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        status: "ข้อมูลสถานะใบสั่งงาน",
        agency: "ข้อมูลสถานะใบสั่งงานตามหน่วยงาน"
      }
    });
  };

  useEffect(() => handleChangeTab(state || "status"), []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Work Order Status Information Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={state || "status"}
          onSelect={(k) => handleChangeTab(k)}
        >
          <Tab eventKey="status" title="ข้อมูลสถานะใบสั่งงาน">
            {websiteName === "ข้อมูลสถานะใบสั่งงาน" && <SequenceTab />}
          </Tab>

          <Tab eventKey="agency" title="ข้อมูลสถานะใบสั่งงานตามหน่วยงาน">
            {websiteName === "ข้อมูลสถานะใบสั่งงานตามหน่วยงาน" && (
              <DepartJobTab />
            )}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
